import { SIZE_50 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';

import { ChoroplethMapChart } from '@/components/composite/Charts/ChoroplethMapChart';

export const countriesDistributionConfig = {
    height: 300,
    name: {
        name: 'chart.facebook.countries_distribution_country',
        value: 'chart.facebook.countries_distribution_value',
        country: 'chart.facebook.countries_distribution_country',
        percentage: 'percentage'
    },
    tooltip: 'chart.facebook.countries_distribution_tooltip',
    noLegend: true,
    datePickerDoesNotApply: true,
    social: FACEBOOK,
    id: 'countries_distribution',
    size: SIZE_50,
    title: 'chart.facebook.countries_distribution_fans',
    type: 'chart',
    element: ChoroplethMapChart,
    defaultFilter: 'global',
    defaultTableSorting: [{ id: 'value', desc: true }]
};
